var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatinete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h6.016v5.92H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.086 19.08c-1.659 0-3.008 1.329-3.008 2.96 0 1.632 1.35 2.96 3.008 2.96s3.008-1.328 3.008-2.96c0-1.631-1.35-2.96-3.008-2.96",
    fill: "#DA322A"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.984 19.08)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.008 0C1.35 0 0 1.328 0 2.96s1.35 2.96 3.008 2.96c1.659 0 3.008-1.328 3.008-2.96S4.666 0 3.008 0",
    fill: "#DA322A",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.894 16.013c.007-.007.01-.016.016-.024a.657.657 0 0 0 .098-.182.679.679 0 0 0 .02-.065.684.684 0 0 0 .012-.274c-.001-.01 0-.018-.002-.028L20.758 4h-4.495a.706.706 0 0 0-.712.7c0 .387.32.7.712.7h3.324l1.99 9.99-4.852 5.95h-5.656c-.347-2.4-2.449-4.253-4.983-4.253a5.045 5.045 0 0 0-3.93 1.857.693.693 0 0 0 .11.984.72.72 0 0 0 1.001-.108 3.62 3.62 0 0 1 2.82-1.332c1.99 0 3.61 1.594 3.61 3.553 0 .387.318.7.711.7H17.066a.72.72 0 0 0 .133-.013l.015-.003a.731.731 0 0 0 .117-.035l.02-.008a.714.714 0 0 0 .105-.057l.017-.01a.69.69 0 0 0 .095-.078l.005-.005a.666.666 0 0 0 .048-.053l5.273-6.466z",
    fill: "#DA322A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatinete);
export default __webpack_public_path__ + "static/media/patinete.20bc8041.svg";
export { ForwardRef as ReactComponent };